export enum MFNames {
	reki = 'reki',
	efr = 'efr',
	apiEfrAdmin = 'apiEfrAdmin',
	efrAdmin = 'efrAdmin',
	apiWebStatic = 'apiWebStatic',
	webStaticAdmin = 'webStaticAdmin',
	efrFast = 'efrFast',
	efrDrom = 'efrDrom',
	efrCommon = 'efrCommon',
	efrT2 = 'efrT2',
	apiReki = 'apiReki',
	apiEfr = 'apiEfr',
	common = 'common',
	designTokens = 'designTokens',
	webStatic = 'webStatic',
	staticFiles = 'staticFiles',
	uiKit = 'uiKit',
}

export type MFNamesKeys = keyof typeof MFNames;
